import axios from 'axios';

/*export const apiClient = axios.create({
  baseURL: "http://localhost:8080",
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  }
});*/


/*export const apiClient = axios.create({
  baseURL: "https://san-back-staging.onrender.com",
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  }
});*/

export const apiClient = axios.create({
  baseURL: "https://api.sangroupbms.com",
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  }
});
